/** Host natif legacy — l’app Burok Linking attend encore `link.burok.app`. */
export const BUROK_LINK_NATIVE_HOST = 'link.burok.app';

/** Origine publique canonique des short links app. */
export const BUROK_PUBLIC_ORIGIN = 'https://burok.app';

export const IOS_STORE_URL = 'https://apps.apple.com/app/burok/id1234567890';
export const ANDROID_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.otjack007.burokapp';

function firstPathSegment(shortCode: string): string {
  return shortCode.trim().replace(/^\/+/, '').split('/')[0] ?? '';
}

/**
 * Deeplink natif pour un lien court.
 * Format : `burokapp://link.burok.app/{shortCode}` (compat Linking app).
 */
export function generateBurokAppLinkNativeDeeplink(shortCode: string): string {
  const segment = firstPathSegment(shortCode);
  if (!segment) return `burokapp://${BUROK_LINK_NATIVE_HOST}/`;
  return `burokapp://${BUROK_LINK_NATIVE_HOST}/${encodeURIComponent(segment)}`;
}

/** URL publique canonique (nouveau domaine). */
export function generateBurokPublicShortUrl(shortCode: string): string {
  const segment = firstPathSegment(shortCode);
  return segment
    ? `${BUROK_PUBLIC_ORIGIN}/link/${encodeURIComponent(segment)}`
    : `${BUROK_PUBLIC_ORIGIN}/link`;
}

/** Deeplink natif fallback pour `/pay` (query conservée). */
export function generateBurokPayNativeDeeplink(search: string): string {
  const q = search.startsWith('?') ? search.slice(1) : search;
  return q ? `burokapp://pay?${q}` : 'burokapp://pay';
}

/**
 * Deeplink natif pour un path app.burok.app (messages, friend, kiosk…).
 * Ex. `/friend/abc?x=1` → `burokapp://friend/abc?x=1`
 * (inverse de la normalisation app → https://app.burok.app/...)
 */
export function generateBurokAppPathNativeDeeplink(
  pathname: string,
  search = ''
): string {
  const path = pathname.replace(/^\/+/, '');
  const q = search.startsWith('?') ? search : search ? `?${search}` : '';
  if (!path) return q ? `burokapp://${q}` : 'burokapp://';
  return `burokapp://${path}${q}`;
}

export function detectPlatform(): 'ios' | 'android' | 'unknown' {
  if (typeof navigator === 'undefined') return 'unknown';
  const ua = navigator.userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(ua)) return 'ios';
  if (/android/.test(ua)) return 'android';
  return 'unknown';
}

export function isMobile(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}

export function storeHrefForPlatform(platform: 'ios' | 'android' | 'unknown'): string {
  return platform === 'ios' ? IOS_STORE_URL : ANDROID_STORE_URL;
}
